import React from "react";
import { PrefillInput } from "@components/input";

export const Street = () => (
  <PrefillInput
    title="Street"
    placeholder="Street"
    name="street"
  />
);